/**
 * Normaliza una etiqueta de modificador o de nota rápida para COMPARAR:
 * minúsculas, sin tildes/diéresis, espacios colapsados y recortados.
 *
 * Es el único normalizador del flujo guiado. Lo usan la heurística de
 * clasificación agregar/quitar (classifyModifier) y la dedup entre una opción
 * de modificador y una nota rápida con la misma etiqueta (guidedSteps). Tener
 * dos normalizadores distintos haría que "Sin Cebolla" se deduplique en un
 * lado y se duplique en el otro.
 *
 * Nunca se usa para MOSTRAR ni para lo que viaja a la cocina — ahí va siempre
 * el texto original.
 */
export function normalizeLabel(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
}
